import { avecAlpha } from '../../../lib/couleurs'

/**
 * Etape 2 (parcours A) : « Ou le vendre ? » — prototype v7.4, WizardOffre/canaux.
 *
 * Ecran qui N'EXISTAIT PAS (S68, banc d'essai visuel). Le choix du canal etait
 * enfoui en bas de l'ecran « Vos prix », en pastilles, et seulement s'il y
 * avait plusieurs modules. Le prototype en fait une decision a part entiere,
 * AVANT le prix — parce que le prix depend du canal (30 % de commission en
 * Tournee, 10 % en Evenement).
 *
 * Forme reprise a l'identique : rappel du produit en carte de verre, puis une
 * carte par canal avec un INTERRUPTEUR (pas une pastille), teintee de la
 * couleur du canal quand il est actif.
 *
 * Les canaux viennent du `catalogue` (`../canaux.js`, source unique) : un lieu
 * masque au BO n'apparait pas, un lieu « Bientôt » ou ferme a l'organisation
 * reste visible mais eteint, avec la raison — on ne cache pas ce qui existe,
 * on dit pourquoi ce n'est pas la.
 */

function StepCanaux({ product, catalogue, canaux, onToggle }) {
  return (
    <div>
      {/* Rappel du produit choisi */}
      <div className="panneau-verre rounded-2xl px-3.5 py-[11px] mb-3.5 flex items-center gap-2.5">
        <span className="text-[22px] leading-none">{product?.emoji || product?.category?.emoji || '📦'}</span>
        <div className="min-w-0">
          <p className="text-sm font-bold text-ink truncate">{product?.nom}</p>
          <p className="text-[11px] text-ink/50">
            {[product?.category?.nom, product?.unit, product?.proposition ? 'proposition' : null].filter(Boolean).join(' · ')}
          </p>
        </div>
      </div>

      {catalogue.length === 0 && (
        <p className="text-[13px] text-ink/60">Aucun canal de vente n'est ouvert pour le moment.</p>
      )}

      <div className="flex flex-col gap-2.5">
        {catalogue.map((ch) => {
          const on = ch.ouvert && !!canaux[ch.code]
          return (
            <button
              key={ch.code}
              onClick={() => ch.ouvert && onToggle(ch.code, !on)}
              disabled={!ch.ouvert}
              className="flex items-center gap-[13px] px-[15px] py-[13px] rounded-[18px] text-left disabled:opacity-50"
              style={{
                background: on ? avecAlpha(ch.c, 0.1) : 'rgba(255,255,255,0.55)',
                border: on ? `1.5px solid ${ch.c}` : '1px solid rgba(7,62,61,0.08)',
              }}
            >
              <span className="text-[22px] leading-none">{ch.e}</span>
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-bold text-ink">{ch.l}</span>
                <span className="block text-[11px] text-ink/50">{ch.ouvert ? ch.d : ch.raison}</span>
              </span>
              {/* Interrupteur (prototype) */}
              <span
                className="relative flex-shrink-0 rounded-full transition-colors"
                style={{ width: 42, height: 25, background: on ? ch.c : 'rgba(7,62,61,0.15)' }}
              >
                <span
                  className="absolute rounded-full bg-white transition-all"
                  style={{ top: 3, left: on ? 20 : 3, width: 19, height: 19, boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }}
                />
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default StepCanaux
